import ReactApexChart from 'react-apexcharts';
import React, {useEffect, useState} from 'react';
import classes from './PieChart.module.scss';
import Loader from "./Loader";

const PieChart = (props) => {
    // console.log(props.data.x.value)
    const [series, setSeries] = useState(props.data.x.value);
    const [options] = useState({
        labels: props.data.x.labels,
        legend: {
            show: true,
            position: 'bottom',
            showForZeroSeries: true,
            showForSingleSeries: true,
            fontSize: "12px",
            fontFamily: "Arial, sans-serif",
        },
        grid: {
            padding: {
                top: 45,
                right: 0,
                bottom: -30,
                left: 0
            },
        },
        tooltip: {
            enabled: true,
            y: {
                formatter: (val) => val + ' ' + props.data.x.unit,
            },
        },
        plotOptions: {
            pie: {
                startAngle: -120,
                endAngle: 120,
                customScale: 1.5,
                donut: {
                    size: '65%',
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            showAlways: true,
                            label: props.name,
                            fontSize: '10px',
                            fontFamily: 'Arial, sans-serif',
                            fontWeight: 600,
                            formatter: ()=>{return props.data.total.value + ' ' + props.data.total.unit}
                        },
                        value: {
                            show: false,
                            fontSize: '14px',
                            fontFamily: 'Arial, sans-serif',
                            offsetY: -5,
                        },
                    },
                },
            },
        },
    });
    const updateChartData = async () => {
        const newSeries = props.data.x.value;
        setSeries(newSeries);
    };
    useEffect(() => {
        updateChartData().then(null)
    }, [])
    return (
        <div className={classes.wrapper}>
            <ReactApexChart
                options={options}
                series={series}
                type="donut"
                />
        </div>
    );
}

export default PieChart;